"use client"

import { useCallback } from "react"
import { usePathname } from "next/navigation"
import { useAuthStore } from "@/features/auth/store"
import { signOut as serverSignOut } from "@/features/auth/actions"

export function useAuth() {
  const pathname = usePathname()
  const user = useAuthStore((state) => state.user)
  const profile = useAuthStore((state) => state.profile)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const isLoading = useAuthStore((state) => state.isLoading)
  const setUser = useAuthStore((state) => state.setUser)
  const setProfile = useAuthStore((state) => state.setProfile)
  const setLoading = useAuthStore((state) => state.setLoading)
  const storeLogout = useAuthStore((state) => state.logout)

  const login = useCallback(
    (user: Parameters<typeof setUser>[0]) => {
      setUser(user)
      setLoading(false)
    },
    [setUser, setLoading]
  )

  const logout = useCallback(async () => {
    storeLogout()
    await serverSignOut(pathname ?? "/")
  }, [storeLogout, pathname])

  return {
    user,
    profile,
    isAuthenticated,
    isLoading,
    login,
    logout,
    setUser,
    setProfile,
    setLoading,
  }
}
